import { keys } from '@/api/api.keys';
import { queryBlendedAllBets } from '@/api/blended/bets/bets';
import { BetsTable } from '@/common/components/BetsTable/BetsTable';
import LoadingSpinner from '@/common/components/LoadingSpinner';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { useBlendedAllBets } from './services/Bets.config';
import { PaginationV3 } from '@/common/components/Pagination/PaginationV3';

export default function AllBets() {
  const [params] = useSearchParams();
  const raceId = params.get('id');
  const { allBetsColumns } = useBlendedAllBets();

  const limit = 20;
  const [offset, setOffset] = useState<string>('0');
  const [history, setHistory] = useState<string[]>([]);
  const { data, isLoading } = useQuery(
    [keys.blendedAllBets, offset, !!raceId],
    () => queryBlendedAllBets({ race_id: raceId ?? '', limit, offset })
  );
  const isLastFetch = (data?.bets?.length ?? 0) < limit;

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <BetsTable
        columns={allBetsColumns}
        data={data?.bets ?? []}
        loading={isLoading}
      />

      <PaginationV3
        nextDisabled={isLastFetch}
        offset={offset}
        setOffset={(val) => setOffset(val)}
        onPageChange={(newOffset) => setOffset(newOffset)}
        useHistory
        history={history}
        setHistory={setHistory}
        nextOffsetId={!isLastFetch ? data?.paging?.next_offset : undefined}
      />
    </>
  );
}
